export const EVENT_DELETE_JOB_CONFIRM = 'delete_job_confirm';
